import React from 'react';
import { Card, Statistic, Typography, Space } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined, MinusOutlined } from '@ant-design/icons';
import { formatMetric } from '../../utils/analyticsUtils';

const { Text } = Typography;

interface AnalyticsCardProps {
  title: string;
  value: number;
  format?: 'currency' | 'percentage' | 'number' | 'time';
  trend?: 'up' | 'down' | 'stable';
  change?: number;
  subtitle?: string;
  loading?: boolean;
}

const AnalyticsCard: React.FC<AnalyticsCardProps> = ({
  title,
  value,
  format = 'number',
  trend,
  change,
  subtitle,
  loading = false
}) => {
  const getTrendIcon = () => {
    switch (trend) {
      case 'up':
        return <ArrowUpOutlined style={{ color: '#52c41a' }} />;
      case 'down':
        return <ArrowDownOutlined style={{ color: '#f5222d' }} />;
      case 'stable':
        return <MinusOutlined style={{ color: '#faad14' }} />;
      default:
        return null;
    }
  };

  const getTrendColor = () => {
    switch (trend) {
      case 'up':
        return '#52c41a';
      case 'down':
        return '#f5222d';
      case 'stable':
        return '#faad14';
      default:
        return '#666';
    }
  };

  return (
    <Card loading={loading}>
      <Statistic
        title={title}
        value={formatMetric(value, format)}
        valueStyle={{ fontSize: '24px', fontWeight: 'bold' }}
      />
      
      {(trend || change !== undefined || subtitle) && (
        <Space style={{ marginTop: 8 }} size="small">
          {trend && getTrendIcon()}
          {change !== undefined && (
            <Text style={{ color: getTrendColor() }}>
              {change > 0 ? '+' : ''}{formatMetric(change, format === 'currency' ? 'percentage' : format)}
            </Text>
          )}
          {subtitle && (
            <Text type="secondary">{subtitle}</Text>
          )}
        </Space>
      )}
    </Card>
  );
};

export default AnalyticsCard; 